/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TraceNode
 */
export interface TraceNode {
    /**
     * 
     * @type {Array<object>}
     * @memberof TraceNode
     */
    children: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof TraceNode
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TraceNode
     */
    r?: number;
    /**
     * 
     * @type {number}
     * @memberof TraceNode
     */
    w?: number;
    /**
     * 
     * @type {number}
     * @memberof TraceNode
     */
    totalChildren?: number;
}

export function TraceNodeFromJSON(json: any): TraceNode {
    return TraceNodeFromJSONTyped(json, false);
}

export function TraceNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TraceNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'children': json['children'],
        'name': json['name'],
        'r': !exists(json, 'r') ? undefined : json['r'],
        'w': !exists(json, 'w') ? undefined : json['w'],
        'totalChildren': !exists(json, 'total_children') ? undefined : json['total_children'],
    };
}

export function TraceNodeToJSON(value?: TraceNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'children': value.children,
        'name': value.name,
        'r': value.r,
        'w': value.w,
        'total_children': value.totalChildren,
    };
}


